/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2022-08-03 15:00:49
 * @LastEditors: kai.zhou
 * @LastEditTime: 2022-08-03 15:04:50
 */
export default function gtinit(){
  var winurlsource = ''
  let url = _parseQueryString("?" + window.location.href.split("?")[1]);
  if (url.source) {
    if (url.source.toLowerCase() === 'phonerepairsns') {
      winurlsource = '_SNS'
    } else if (url.source.toLowerCase() === 'phonerepairweb') {
      winurlsource = '_Web'
    } else if (url.source.toLowerCase() === 'apppost' || url.source.toLowerCase() === 'phonerepair' || url.source.toLowerCase() === 'app') {
      winurlsource = '_App'
    } else {
      winurlsource = '_' + (url.source.toLowerCase());
    }
  } else {
    winurlsource = '_H5'
  }
  return winurlsource;
}
function _parseQueryString(queryString) {
  if (queryString && queryString.startsWith("?")) {
    const result = {};
    queryString
      .slice(1)
      .split("&")
      .forEach((item) => {
        const keyValueList = item.split("=");
        result[keyValueList[0]] = decodeURIComponent(keyValueList[1]);
      });
    return result;
  } else {
    return {};
  }
}